document.addEventListener("DOMContentLoaded", () => {
  window.lightbox = new PhotoSwipeLightbox({
    gallery: "#pi-product__gallery-photoswipe-slider",
    children: "a",
    // dynamic import is not supported in UMD version
    pswpModule: PhotoSwipe,
  });
  window.lightbox.init();

  // Add click event on the body then if the target match with the selector
  document.body.addEventListener("click", (event) => {
    if (event.target.matches("[data-photoswipe-index]")) {
      event.preventDefault();
      window.lightbox.loadAndOpen(
        parseInt(event.target.dataset.photoswipeIndex)
      );
    }
  });
});
